export const PASSWORD_RULES = {
  minLength: 8,
  hasUpperCase: /[A-Z]/,
  hasLowerCase: /[a-z]/,
  hasNumber: /[0-9]/,
  hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/,
};

export const PASSWORD_STRENGTH_LEVELS = [
  { max: 20, label: "Very weak", tone: "bad" },
  { max: 40, label: "Weak", tone: "warn" },
  { max: 60, label: "Fair", tone: "mid" },
  { max: 80, label: "Strong", tone: "good" },
  { max: 100, label: "Very strong", tone: "great" },
];

export const validateNewPassword = (password) => {
  const errors = [];
  if (password.length < PASSWORD_RULES.minLength) {
    errors.push(`At least ${PASSWORD_RULES.minLength} characters`);
  }
  if (!PASSWORD_RULES.hasUpperCase.test(password)) errors.push("1 uppercase");
  if (!PASSWORD_RULES.hasLowerCase.test(password)) errors.push("1 lowercase");
  if (!PASSWORD_RULES.hasNumber.test(password)) errors.push("1 number");
  if (!PASSWORD_RULES.hasSpecialChar.test(password)) errors.push("1 symbol");
  return errors;
};

export const passwordStrengthScore = (password) => {
  if (!password) return 0;
  let score = 0;
  if (password.length >= PASSWORD_RULES.minLength) score += 1;
  if (PASSWORD_RULES.hasUpperCase.test(password)) score += 1;
  if (PASSWORD_RULES.hasLowerCase.test(password)) score += 1;
  if (PASSWORD_RULES.hasNumber.test(password)) score += 1;
  if (PASSWORD_RULES.hasSpecialChar.test(password)) score += 1;
  return (score / 5) * 100;
};

export const passwordStrengthLevel = (password) => {
  const score = passwordStrengthScore(password);
  return PASSWORD_STRENGTH_LEVELS.find((level) => score <= level.max) || PASSWORD_STRENGTH_LEVELS[0];
};
